import addToFavorites from '../modules/favorites';
import openComparisonComponent, { addProgramForComparison } from '../modules/comparePrograms';
import '../modules/consultationForm';

const el = {
  filtersBox: document.querySelector('[data-panel="filters-panel"]'),
  resetBtns: Array.from(document.querySelectorAll('[data-element="reset-filters"]')),
  programsContainer: document.querySelector('[data-component="programs-list-filtered"]'),
  searchBtn: document.querySelector('[data-action="search"]'),
  searchInput: document.querySelector('[data-element="search-box"] input'),
  searchListInputs: Array.from(document.querySelectorAll('[data-element="searchList"]')),
  addCountryInput: document.querySelector('#add-country'),
  invisibleCountries: Array.from(document.querySelectorAll('.country-filter .invisible-values .filter-value')),
  visibleCountriesBox: document.querySelector('.country-filter .visible-values'),
  addSpecializationInput: document.querySelector('#add-spacialization'),
  invisibleSpecializations: Array.from(document.querySelectorAll('.specializations-filter .invisible-values .filter-value')),
  visibleSpecializationsBox: document.querySelector('.specializations-filter .visible-values'),
  popularFiltersBox: document.querySelector('[data-element="popular-filters-container"]'),
  skeleton: document.querySelector('.skeleton-loader'),
  mobFiltersBtn: document.querySelector('.mob.filters-btn'),
  mobSearchBtn: document.querySelector('.mob.search-btn'),
}

let filters = JSON.parse(el.programsContainer.dataset.filters);


function pagination() {
  Array.from(el.programsContainer.querySelectorAll('[data-element="pagination-link"]')).forEach(function (element) {

    if (element.dataset.eventPaginate) {
      return true;
    }

    element.dataset.eventPaginate = true;

    element.addEventListener('click', function (event) {

      event.preventDefault();

      element.dataset.page == 1 ? delete filters.page : filters.page = element.dataset.page;

      if (element.parentNode.classList.contains('active')) {
        return true;
      }

      const url = constructUrl('/mba', filters, setUrlParameter);
      getPrograms(url);

      scroll({ top: 0, left: 0, behavior: "smooth", });
    });
  });
}

function sortProgramList() {
  document.querySelector('[data-element="order-by"]')?.addEventListener('change', function (e) {
    delete filters.page;

    filters['_orderby'] = e.target.value;

    const url = constructUrl('/mba', filters, setUrlParameter);
    getPrograms(url);
  });
}

function toShowOrHideResetBtns(data) {
  const numOfSelectedFilters = Object.keys(data).length;

  if (numOfSelectedFilters > 1) {

    el.resetBtns.forEach(btn => btn.classList.replace('hidden', 'show'));
    el.mobFiltersBtn.classList.add('solid');

  } else if (numOfSelectedFilters === 1) {

    if (data.name) {
      el.resetBtns.forEach(btn => btn.classList.replace('show', 'hidden'));
      el.mobFiltersBtn.classList.remove('solid');
    } else {
      el.resetBtns.forEach(btn => btn.classList.replace('hidden', 'show'));
      el.mobFiltersBtn.classList.add('solid');
    }

  } else {

    el.resetBtns.forEach(btn => btn.classList.replace('show', 'hidden'));
    el.mobFiltersBtn.classList.remove('solid');

  }
}

function menageFilters() {

  el.filtersBox.querySelectorAll('[data-element="filter-value"]').forEach(function (element) {

    element.addEventListener('click', function (e) {
      e.preventDefault();

      let filterName = element.dataset.filter;
      let filterValue = element.dataset.value;


      /**
       * Add/Remove value to/from filters
       */
      if (filters[filterName]) {

        let values = filters[filterName].split(',');

        if (values.indexOf(filterValue) > -1) {

          values = values.filter(element => element !== filterValue);
          filters[filterName] = values.join(',');
          element.parentElement.classList.remove('selected');

          if (filters[filterName] == '') {
            delete filters[filterName];
          }

        } else {

          filters[filterName] += ',' + filterValue;
          element.parentElement.classList.add('selected');

        }
      } else {

        filters[filterName] = filterValue;
        element.parentElement.classList.add('selected');

      }



      filters.page ? delete filters.page : true;
      filters['_orderby'] ? delete filters['_orderby'] : true;

      toShowOrHideResetBtns(filters);

      const url = constructUrl('/mba', filters, setUrlParameter);
      getPrograms(url);
    });
  })

}

function resetFilters(resetBtns) {

  resetBtns?.forEach(btn => {

    btn.addEventListener('click', function (e) {

      e.preventDefault();

      if (Object.keys(filters).length > 0) {

        if (filters.name) {
          filters = { name: filters.name };
        } else {
          filters = {};
        }

        if (btn.dataset.elementFromEmptyList) {
          filters = {};
          document.querySelector('input[data-filter="name"]').value = "";
          document.querySelector('.search-box .clear').classList.replace('show', 'hidden');
          el.mobSearchBtn.classList.remove('solid');
        }

        Array.from(document.querySelectorAll('[data-element="filter-value"]')).forEach(function (element) {
          element.parentElement.classList.remove('selected');
        })
        el.mobFiltersBtn.classList.remove('solid');


        const url = constructUrl('/mba', filters, setUrlParameter);
        getPrograms(url);

        el.resetBtns?.forEach(resetBtn => resetBtn.classList.replace('show', 'hidden'))

      }


    })
  })

}

function createNewPopularFilterElFromResult(filter) {
  const newAncor = document.createElement('a');
  newAncor.textContent = filter.name;
  newAncor.setAttribute('class', 'popular-filter skeleton');
  newAncor.setAttribute('href', filter.url);

  el.popularFiltersBox.appendChild(newAncor);
}

function getPrograms(url) {

  el.skeleton?.classList.add('active');

  fetch(url, {
    method: 'GET',
    mode: "cors",
    credentials: "same-origin",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    }
  })
    .then(response => response.json())
    .then(function (result) {

      el.skeleton?.classList.remove('active');

      if (result.popular_filters && result.popular_filters.length > 0) {

        Array.from(el.popularFiltersBox.querySelectorAll('a'))?.forEach(oldFilter => oldFilter.remove());
        document.querySelector('.popular-filters-wrapper').classList.remove('hidden');
        result.popular_filters?.forEach(createNewPopularFilterElFromResult);

      } else {
        document.querySelector('.popular-filters-wrapper').classList.add('hidden');
      }

      if (result.title && result.title != "") {
        document.querySelector('h1').innerHTML = result.title;
      }


      if (result.html && result.html.trim() !== '') {
        el.programsContainer.innerHTML = result.html;

        const resetBtnsArr = Array.from(el.programsContainer.querySelectorAll('[data-element="reset-filters"]'));

        addToFavorites();
        pagination();
        sortProgramList();
        addProgramForComparison();
        resetFilters(resetBtnsArr);

        return true
      }

      /**
       * Set an error message when the source did not return any results
       */
      return el.programsContainer.innerHTML = 'Sorry, the list is empty at the moment';
    })
    .catch(function (error) {
      el.skeleton?.classList.remove('active');
      return error ? el.programsContainer.innerHTML = error : el.programsContainer.innerHTML = 'Sorry, we were unable to load the information from the source'
    });

}

function setUrlParameter(uri, key, value) {

  let index = uri.indexOf('#');
  let fragment = index === -1 ? '' : uri.substring(index);
  uri = index === -1 ? uri : uri.substring(0, index);

  let expression = new RegExp("([?&])" + key + "=.*?(&|$)", "i");

  let separator = uri.indexOf('?') !== -1 ? "&" : "?";

  if (uri.match(expression)) {
    uri = uri.replace(expression, '$1' + key + "=" + value + '$2');
  } else {
    uri = uri + separator + key + "=" + value;
  }

  return uri + fragment;
}

function constructUrl(path, filters, setURLfn) {
  /**
   * Append the filters for the fetch
   */
  if (Object.keys(filters).length) {
    if ('subject-area' in filters) {
      let subject_area = filters['subject-area'].split(',');
      if (subject_area.length == 1) {
        path = path + "/" + filters['subject-area'];
      }
    }
    if ('country' in filters) {
      let country = filters['country'].split(',');
      if (country.length == 1) {
        path = path + "/" + filters.country;
      }
    }
    if ('program-type' in filters) {
      let program_type = filters['program-type'].split(',');
      if (program_type.length == 1) {
        path = path + "/" + filters['program-type'];
      }
    }

    Object.keys(filters).forEach(key => {

      if (key == 'country' || key == 'subject-area' || key == 'program-type') {
        let value = filters[key].split(',')
        if (value.length == 1) {
          return;
        }
      }

      if (key !== '_orderby') {
        path = setURLfn(path, key, filters[key]);
      }
    });
  }

  /**
   *  TODO - Използвайте pushState или hashchange за промяна на URL адреса при AJAX взаимодействия; 
   *  Но не и при смяна на ordering i direction
   */

  if (filters['_orderby']) {
    path = setURLfn(path, '_orderby', filters['_orderby'])
  } else {
    window.history.pushState({}, '', path);
  }
  
  path = setURLfn(path, 'requested_via', 'ajax');

  return path
}

function toggleFilterValues() {

  Array.from(document.querySelectorAll('[data-element="toggler"]')).forEach(function (btn) {

    btn.addEventListener('click', function (e) {

      e.preventDefault();

      let container = btn.previousElementSibling;
      container.parentElement.classList.toggle('active');

      if (container.scrollHeight > 300) {
        container.classList.add('filters-scroll');
      }

    });
  })
}

function searchURLManipulation(inputValue, isClear) {

  if (inputValue.trim()) {
    filters = { name: encodeURIComponent(inputValue) };

    if (!isClear) {
      Array.from(document.querySelectorAll('[data-element="filter-value"]')).forEach(function (element) {
        element.parentElement.classList.remove('selected');
      })
    }

    el.mobSearchBtn.classList.add('solid');

  } else {
    delete filters.name;
    el.mobSearchBtn.classList.remove('solid');
  }

  // inputValue.trim() ? filters = { name: encodeURIComponent(inputValue) } : delete filters.name;

  toShowOrHideResetBtns(filters);

  const url = constructUrl('/mba', filters, setUrlParameter);
  getPrograms(url);
}

function searchPrograms() {

  document.querySelector('.search-box .clear').addEventListener('click', function (e) {
    el.searchInput.value = '';
    e.currentTarget.classList.replace('show', 'hidden');
    searchURLManipulation('', true);
  });

  el.searchBtn.addEventListener('click', function (e) {
    e.preventDefault();

    if (!(filters.name || el.searchInput.value.trim())) {
      return
    }

    searchURLManipulation(el.searchInput.value)
  });

  el.searchInput.addEventListener("keypress", function (event) {

    if (event.key === "Enter") {
      event.preventDefault();

      if (!(filters.name || el.searchInput.value.trim())) {
        return
      }

      searchURLManipulation(el.searchInput.value)
    }
  });

  el.searchInput.addEventListener('keyup', function (e) {

    if (e.target.value.trim() === '') {
      document.querySelector('.search-box .clear').classList.replace('show', 'hidden');
    } else {
      document.querySelector('.search-box .clear').classList.replace('hidden', 'show');
    }
  });

}

function selectedFilterValuesMoveToVisible(addFilterInput, visibleFiltersBox) {

  return function (filterItem) {
    if (filterItem.classList.contains('selected')) {
      visibleFiltersBox.appendChild(filterItem);
    } else {

      filterItem.addEventListener('click', function addFilterItemToVisible(e) {

        visibleFiltersBox.appendChild(filterItem);
        addFilterInput.value = '';

        el.invisibleCountries.forEach(filterItem => filterItem.style.display = '');
        filterItem.removeEventListener('click', addFilterItemToVisible);

      })
    }

  }
}

function searchList() {

  el.searchListInputs.forEach(input => {
    input.addEventListener('keyup', function (e) {

      const listBox = document.querySelector(e.currentTarget.dataset.adTarget);
      const value = e.currentTarget.value.trim().toUpperCase();

      Array.from(listBox.querySelectorAll('.filter-value')).forEach(item => {

        const itemContent = item.querySelector('a').textContent.toUpperCase();
        itemContent.includes(value) ? item.style.display = '' : item.style.display = 'none';

      })
    })
  })

}

function searchListToggle() {

  el.searchListInputs.forEach(addFilterInput => {

    addFilterInput.addEventListener('focus', function (e) {
      const body = document.body;
      const input = e.currentTarget;
      const listBox = document.querySelector(e.currentTarget.dataset.adListBox);
      const dropdown = document.querySelector(e.currentTarget.dataset.adTarget);

      dropdown.classList.add('active');
      dropdown.style.maxHeight = `${dropdown.scrollHeight}px`;

      body.addEventListener('click', function closeOnClick(e) {

        if (!(e.target == input.parentNode || input.parentNode.contains(e.target)) && !(e.target == dropdown || listBox.contains(e.target))) {
          dropdown.classList.remove('active');
          dropdown.style.maxHeight = dropdown.style.maxHeight = null;
          body.removeEventListener('click', closeOnClick)
        }

        if (!dropdown.classList.contains('active')) {
          body.removeEventListener('click', closeOnClick)
        }

      })

    })
  })
}

document.addEventListener('DOMContentLoaded', function (e) {

  openComparisonComponent();
  addProgramForComparison();

  toggleFilterValues();
  menageFilters();
  resetFilters(el.resetBtns);
  el.invisibleCountries.forEach(selectedFilterValuesMoveToVisible(el.addCountryInput, el.visibleCountriesBox));
  el.invisibleSpecializations.forEach(selectedFilterValuesMoveToVisible(el.addSpecializationInput, el.visibleSpecializationsBox));
  searchList();
  searchListToggle();

  searchPrograms();
  pagination();

  sortProgramList();
})

// Reload page when you click back button in browser
window.addEventListener('popstate', (e) => window.location.reload())